var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgUserHollow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83252 6.5625C7.83252 4.66402 9.37154 3.125 11.27 3.125C13.1685 3.125 14.7075 4.66402 14.7075 6.5625C14.7075 8.46098 13.1685 10 11.27 10C9.37154 10 7.83252 8.46098 7.83252 6.5625ZM13.5438 10.374C14.8398 9.59921 15.7075 8.18219 15.7075 6.5625C15.7075 4.11174 13.7208 2.125 11.27 2.125C8.81926 2.125 6.83252 4.11174 6.83252 6.5625C6.83252 8.18219 7.70029 9.59921 8.99627 10.374C6.21129 11.3205 4.20752 13.9575 4.20752 17.0625V18.375C4.20752 18.6511 4.43138 18.875 4.70752 18.875C4.98366 18.875 5.20752 18.6511 5.20752 18.375V17.0625C5.20752 13.7143 7.92179 11 11.27 11C14.6182 11 17.3325 13.7143 17.3325 17.0625V18.375C17.3325 18.6511 17.5564 18.875 17.8325 18.875C18.1087 18.875 18.3325 18.6511 18.3325 18.375V17.0625C18.3325 13.9575 16.3288 11.3205 13.5438 10.374Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgUserHollow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-hollow.f368f69040567ad1e5ac18e9f63ce56a.svg";